var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -9.98152,
    y: -9.98152,
    width: 118.963,
    height: 118.963
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.99px)",
      clipPath: "url(#bgblur_0_204_1540_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 9.98152,
    width: 99,
    height: 99,
    rx: 19.8,
    fill: "white",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16406,
    y: 8.27881,
    width: 82.3279,
    height: 82.3279,
    rx: 16.4656,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.522 50.1759C60.9722 52.2648 58.3741 53.7408 53.1776 56.6931C48.1542 59.5469 45.6426 60.9739 43.6185 60.4003C42.7817 60.1631 42.0192 59.7128 41.4043 59.0924C39.917 57.5918 39.917 54.6812 39.917 48.8601C39.917 43.039 39.917 40.1284 41.4043 38.6278C42.0192 38.0074 42.7817 37.557 43.6185 37.3199C45.6426 36.7463 48.1542 38.1733 53.1776 41.0271C58.3741 43.9793 60.9722 45.4554 61.522 47.5443C61.7489 48.4066 61.7489 49.3136 61.522 50.1759Z",
    fill: "#121212"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_204_1540_clip_path",
    transform: "translate(9.98152 9.98152)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    rx: 19.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/VIDEO-PLAY.acf42fd8cfdc685f81a48fee5b5e6966.svg";
export { ForwardRef as ReactComponent };